import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
    Observable,
    catchError,
    throwError
} from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { DialogService } from 'src/app/services/dialog.service';


@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private notify: DialogService,
    private authService: AuthService,
    private router: Router,
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          if (error.url && error.url.toLowerCase().includes('/useraccount/')) {
            this.router.navigate(['/authentication/unauthorized']);
          }
          else {
            console.error('[HTTP 401] triggering logout+login for URL:', error.url);
            // this.authService.logout();
            // this.authService.login();
          }
        }
        this.notify.popApiError(error);
        return throwError(() => error);
      })
    );
  }
}
